// extracted by mini-css-extract-plugin
export default {"container":"CertificadoDigital_container__nGoaG","labelChat":"CertificadoDigital_labelChat__AbQJd"};